import Flex from 'components/Flex'
import React, { useEffect, useState } from 'react'

import { getInterviweListDetails } from 'modules/InterviewerDashboard/actions'
import {
  HeaderFlex,
  UserName,
  Wrapper,
} from 'modules/InterviewerDashboard/Partials/style'
import { useDispatch } from 'react-redux'
import InterviewerTabel from '../InterviewerList/InterviewerListTabel'
const InterviewerList = () => {
  const dispatch = new useDispatch()
  const [interViewerList, setInterViewerList] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(0)
  const [sortBy, setSortBy] = useState('')

  useEffect(() => {
    ;(async () => {
      setLoading(true)
      let responce = await dispatch(getInterviweListDetails(page, sortBy))
      setInterViewerList(responce)
      setLoading(false)
    })()
    return () => {}
  }, [page, sortBy])

  return (
    <Wrapper>
      <Flex alignCenter spaceBetween>
        <HeaderFlex>
          <UserName>Interviewers</UserName>
        </HeaderFlex>
      </Flex>
      <br></br>

      <InterviewerTabel
        interViewerList={interViewerList}
        loading={loading}
        page={page}
        setPage={setPage}
        setSortBy={setSortBy}
      />
    </Wrapper>
  )
}

export default InterviewerList
